import "./feature-card.scss";
const FeatureCard = (props: {
  title: string;
  content: string;
  color?: string;
}) => {
  return (
    <div className="feature-card">
      <div className="feature-card-title">{props.title}</div>
      <div
        className="feature-card-content"
        style={{ color: props.color || "gray" }}
      >
        {props.content}
      </div>
    </div>
  );
};
export default FeatureCard;
